// Banner upload functions
export function useBannerUpload({
  fileInputRef, currentTab, whiteboards, setBannerImage, lessonId,
  setSaveStatus, handleSave, setDocBanners, setHomeworkBanners,
}) {
  const handleBannerUploadClick = () => {
    fileInputRef.current.click();
  };

  // Функция для сжатия изображения
  const compressImage = (base64String, maxWidth = 800, quality = 0.6) => {
    return new Promise((resolve) => {
              const img = new window.Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        // eslint-disable-next-line no-unused-vars
        const ctx = canvas.getContext('2d');

        // Вычисляем новые размеры
        let { width, height } = img;
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        // Рисуем изображение с новыми размерами
        ctx.drawImage(img, 0, 0, width, height);

        // Конвертируем в base64 с заданным качеством
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        console.log('Image compressed from', base64String.length, 'to', compressedBase64.length, 'characters');
        resolve(compressedBase64);
      };
      img.src = base64String;
    });
  };

  // Функция для сжатия аудио
  // eslint-disable-next-line no-unused-vars
  const compressAudio = (base64String) => {
    return new Promise((resolve) => {
      const audio = new Audio();
      audio.oncanplaythrough = () => {
        // Создаем canvas для записи аудио
        const canvas = document.createElement('canvas');
        // eslint-disable-next-line no-unused-vars
        const ctx = canvas.getContext('2d');

        // Устанавливаем размер canvas
        canvas.width = 1;
        canvas.height = 1;

        // Создаем MediaRecorder для записи аудио с меньшим битрейтом
        const stream = canvas.captureStream();
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus',
          audioBitsPerSecond: 64000 // 64 kbps для экономии места
        });

        const chunks = [];
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.onstop = () => {
          const blob = new Blob(chunks, { type: 'audio/webm' });
          const reader = new FileReader();
          reader.onloadend = () => {
            console.log('Audio compressed from', base64String.length, 'to', reader.result.length, 'characters');
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        };

        mediaRecorder.start();
        setTimeout(() => mediaRecorder.stop(), audio.duration * 1000);
      };
      audio.src = base64String;
    });
  };

  const handleBannerFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log('Banner file selected:', file.name, 'size:', file.size);
      const reader = new FileReader();
      reader.onloadend = async () => {
        console.log('Banner file loaded, result length:', reader.result.length);

        // Сжимаем изображение для экономии места в localStorage
        let processedImage = reader.result;
        console.log('Original image length:', reader.result.length);
        if (reader.result.length > 100 * 1024) { // Если больше 100KB
          console.log('Compressing image...');
          processedImage = await compressImage(reader.result);
          console.log('Compressed image length:', processedImage.length);
        } else {
          console.log('Image is small enough, not compressing');
        }

        // Предупреждаем о больших файлах
        if (processedImage.length > 500 * 1024) { // Если больше 500KB
          console.warn('Image is still very large after compression. Consider using a smaller image.');
          alert('Warning: This image is very large and may cause storage issues. Consider using a smaller image.');
        }

        if (currentTab === 0) {
          // Главный редактор
          console.log('Setting bannerImage for main editor, processedImage length:', processedImage.length);
          console.log('ProcessedImage starts with data:image/:', processedImage.startsWith('data:image/'));
          setBannerImage(processedImage);
          console.log('Set bannerImage for main editor');

          // Автоматически сохраняем урок при изменении баннера
          if (lessonId && lessonId !== 'new') {
            setSaveStatus('saving');
            setTimeout(() => {
              console.log('Auto-saving lesson after banner change');
              handleSave();
            }, 2000); // Сохраняем через 2 секунды, чтобы дать время состоянию обновиться
          }
        } else {
          // Doc или Homework таб - устанавливаем баннер для конкретного таба
          const currentWhiteboard = whiteboards[currentTab - 1];
          if (currentWhiteboard?.type === 'doc') {
            setDocBanners(prev => ({
              ...prev,
              [currentWhiteboard.id]: processedImage
            }));
            console.log('Set bannerImage for doc tab:', currentWhiteboard.id);

            // Автоматически сохраняем урок при изменении баннера
            if (lessonId && lessonId !== 'new') {
              setTimeout(() => {
                handleSave();
              }, 1000); // Сохраняем через 1 секунду
            }
          } else if (currentWhiteboard?.type === 'homework') {
            setHomeworkBanners(prev => ({
              ...prev,
              [currentWhiteboard.id]: processedImage
            }));
            console.log('Set bannerImage for homework tab:', currentWhiteboard.id);

            // Автоматически сохраняем урок при изменении баннера
            if (lessonId && lessonId !== 'new') {
              setTimeout(() => {
                handleSave();
              }, 1000); // Сохраняем через 1 секунду
            }
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return { handleBannerUploadClick, handleBannerFileChange };
}
